import PropTypes from "prop-types";
import { Chevron } from "./IconChevron";
import IconTriangle from "./IconTriangle";
import IconClose from "./IconClose";
import IconExclamation from "./IconExclamation";
import IconEmail from "./IconEmail";
import IconLogo from "./IconLogo";
import IconMedia from "./IconMedia";
import IconNewSearch from "./IconNewSearch";
import IconRemove from "./IconRemove";
import IconSearch from "./IconSearch";
import IconProfile from "./IconProfile";
import IconSettings from "./IconSettings";
import { IconFollowed, Followed } from "./IconFollowed";
import { IconFollow, Follow } from "./IconFollow";
import IconUnfollow from "./IconUnfollow";
import IconBack from "./IconBack";
import IconFeature from "./IconFeature";
import IconForward from "./IconForward";
import { IconExpand } from "./IconExpand";
import { IconCollapse } from "./IconCollapse";
import { Feedback } from "./IconFeedback";
import IconBroadcaster from "./IconBroadcaster";
import IconParalympicsBroadcaster from "./IconParalympicsBroadcaster";

const ICON_TYPES = {
    back: IconBack,
    broadcaster: IconBroadcaster,
    chevron: Chevron,
    triangle: IconTriangle,
    expand: IconExpand,
    collapse: IconCollapse,
    close: IconClose,
    email: IconEmail,
    exclamation: IconExclamation,
    feature: IconFeature,
    forward: IconForward,
    logo: IconLogo,
    play: IconMedia,
    remove: IconRemove,
    search: IconSearch,
    profile: IconProfile,
    paralympicsBroadcaster: IconParalympicsBroadcaster,
    newSearch: IconNewSearch,
    settings: IconSettings,
    followed: Followed,
    follow: Follow,
    unfollow: IconUnfollow,
    feedback: Feedback,
};

const Icon = (props) => {
    const IconComponent = ICON_TYPES[props.type];
    return (
        <span className="icon" data-testid="icon">
            {IconComponent && <IconComponent {...props} />}
        </span>
    );
};

Icon.propTypes = {
    type: PropTypes.oneOf(Object.keys(ICON_TYPES)).isRequired,
};

export { Icon as default, IconFollowed, IconFollow };
